export const ERROR = `ERROR`
